export default __webpack_public_path__ + "static/media/headset.038d470c.svg";